var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import Big from 'big.js';
import { DecimalInput } from '../DecimalInput';
function ensureNumber(value) {
    return isNaN(value) ? 0 : value;
}
function toFloat(value) {
    var floatValue = parseFloat(value);
    return ensureNumber(floatValue);
}
function splitInclusiveValue(valueIncTax, taxRatePercent, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 4; }
    var valueIncTaxDecimal = new Big(valueIncTax);
    var taxRateDecimal = new Big(taxRatePercent).div(100);
    var taxExclusivePortion = new Big(1).minus(taxRateDecimal.div(taxRateDecimal.plus(1)));
    var valueExcTaxDecimal = valueIncTaxDecimal.times(taxExclusivePortion).round(decimalPlaces);
    var valueExcTax = parseFloat(valueExcTaxDecimal.toString());
    var valueTax = parseFloat(valueIncTaxDecimal.minus(valueExcTaxDecimal).toString());
    return {
        valueExcTax: valueExcTax,
        valueTax: valueTax,
    };
}
function splitExclusiveValue(valueExcTax, taxRatePercent, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 4; }
    var valueExcTaxDecimal = new Big(valueExcTax);
    var taxRateDecimal = new Big(taxRatePercent).div(100);
    var valueTaxDecimal = valueExcTaxDecimal.times(taxRateDecimal).round(decimalPlaces);
    var valueTax = parseFloat(valueTaxDecimal.toString());
    return {
        valueExcTax: valueExcTax,
        valueTax: valueTax,
    };
}
function updateNameAndValue(event, name, value) {
    return __assign(__assign({}, event), { target: __assign(__assign({}, event.target), { name: name, value: value }) });
}
/**
 * @deprecated
 * Use `TaxableDecimalInput` to render a decimal input with tax included or excluded
 */
export function TaxableDecimal(props) {
    var _a = props.includesTax, includesTax = _a === void 0 ? false : _a, valueExcTax = props.valueExcTax, valueTax = props.valueTax, nameExcTax = props.nameExcTax, nameTax = props.nameTax, _b = props.taxRatePercent, taxRatePercent = _b === void 0 ? 0 : _b, onValueChangeAll = props.onValueChangeAll, decimalScale = props.decimalScale, onBlurOrg = props.onBlur, onChangeOrg = props.onChange, otherProps = __rest(props, ["includesTax", "valueExcTax", "valueTax", "nameExcTax", "nameTax", "taxRatePercent", "onValueChangeAll", "decimalScale", "onBlur", "onChange"]);
    var value;
    var onValueChange;
    var onBlur;
    var onChange;
    var name;
    var safeTaxRatePercent = ensureNumber(taxRatePercent || 0);
    if (includesTax) {
        value = parseFloat(new Big(valueExcTax).plus(valueTax).toString());
        name = "".concat(nameExcTax, "_plus_").concat(nameTax);
        if (onValueChangeAll !== undefined) {
            onValueChange = function (valueInc) {
                var valueTaxComponents = splitInclusiveValue(ensureNumber(valueInc), safeTaxRatePercent, decimalScale);
                onValueChangeAll(valueTaxComponents.valueExcTax, valueTaxComponents.valueTax);
            };
        }
        if (onBlurOrg !== undefined) {
            onBlur = function (onBlurEvent) {
                var valueTaxComponents = splitInclusiveValue(toFloat(onBlurEvent.target.value), safeTaxRatePercent, decimalScale);
                onBlurOrg(updateNameAndValue(onBlurEvent, nameExcTax, valueTaxComponents.valueExcTax));
            };
        }
        if (onChangeOrg !== undefined) {
            onChange = function (onChangeEvent) {
                var valueTaxComponents = splitInclusiveValue(toFloat(onChangeEvent.target.value), safeTaxRatePercent, decimalScale);
                onChangeOrg(updateNameAndValue(onChangeEvent, nameExcTax, valueTaxComponents.valueExcTax));
            };
        }
    }
    else {
        value = valueExcTax;
        name = nameExcTax;
        if (onValueChangeAll !== undefined) {
            onValueChange = function (valueExc) {
                var valueTaxComponents = splitExclusiveValue(ensureNumber(valueExc), safeTaxRatePercent, decimalScale);
                onValueChangeAll(valueTaxComponents.valueExcTax, valueTaxComponents.valueTax);
            };
        }
        if (onBlurOrg !== undefined) {
            onBlur = function (onBlurEvent) {
                var valueTaxComponents = splitExclusiveValue(toFloat(onBlurEvent.target.value), safeTaxRatePercent, decimalScale);
                onBlurOrg(updateNameAndValue(onBlurEvent, nameExcTax, valueTaxComponents.valueExcTax));
            };
        }
        if (onChangeOrg !== undefined) {
            onChange = function (onChangeEvent) {
                var valueTaxComponents = splitExclusiveValue(toFloat(onChangeEvent.target.value), safeTaxRatePercent, decimalScale);
                onChangeOrg(updateNameAndValue(onChangeEvent, nameExcTax, valueTaxComponents.valueExcTax));
            };
        }
    }
    // Setting the key so switching between modes does not cause a recalculation
    var key = includesTax ? 'includesTax' : 'taxExclusive';
    return (React.createElement(DecimalInput, __assign({}, otherProps, { value: value, onValueChange: onValueChange, onBlur: onBlur, onChange: onChange, decimalScale: decimalScale, name: name, key: key })));
}
TaxableDecimal.defaultProps = {
    includesTax: false,
    taxRatePercent: 0,
};
// need to do this to be able to make the addon-docs work with the props because of the memo
var TaxableDecimalInput = memo(TaxableDecimal);
export default TaxableDecimalInput;
//# sourceMappingURL=TaxableDecimalInput.js.map